<template>
  <lr-link
    :to="`/${urlType}/detail/id/${data.post_id || data.id}`"
    class="article-unit"
    :class="{ 'hover-effect': hoverEffect }"
    target="_blank"
    @mouseover="e => $emit('mouseover', e)"
    @mouseleave="e => $emit('mouseleave', e)"
  >
    <div class="article-unit-body">
      <div class="article-unit-title ellipsis">
        {{ data.post_title || data.title }}
      </div>
      <div class="article-unit-content ellipsis-2">
        {{ data.post_excerpt }}
      </div>
    </div>
    <div class="article-unit-boot">
      <!-- 有tags -->
      <template v-if="showTags">
        <div class="article-tag">
          <span
            class="tag"
            v-for="(tag, idx) in data.tags || []"
            :key="idx"
            >{{ tag }}</span
          >
        </div>
      </template>
     <template v-else>
        <span class="article-unit-time">
          <img class="view" src="~/assets/image/icon/time.svg" alt="" />
          {{ genDisplayTime(data) }}
        </span>
     </template>
      <span class="article-unit-hits">
        <img class="view" src="~/assets/image/icon/view.svg" alt="" />
        {{ data.post_hits | crowd }}
      </span>
      <slot></slot>
    </div>
  </lr-link>
</template>

<script>
import { getYYYYMMDD } from '@/common/utils';

export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        post_title: 'AI智能动画',
        title: '',
        course_num: 0,
        thumbnail:
          '//s1.wpsacdm.cache.wpscdn.cn/wps_statics/wps_academy/themes/academy/public/assets/images/cover/single_ppt.png',
        post_hits: 121,
        create_time: '',
        price: 123,
        post_excerpt:
          'WPS里有很多实用技巧，熟练掌握它们，不仅可以提高工作效率，还能免去一些重复性劳动',
      }),
    },

    hoverEffect: {
      type: Boolean,
      default: true,
    },

    urlType:{
      type:String,
      default:'article'
    },

    showTags: { // 显示文章标签
      type: Boolean,
      default: false
    }
  },

  methods: {
    genDisplayTime(item) {
      if (item.published_time) {
        return getYYYYMMDD(item.published_time);
      }

      if (item.create_time) {
        //兼容用户中心user页面的接口数据createTime是'2021-03-12'这种字符串
        const time = item.create_time;
        const isString = typeof time === 'string';

        if (isString && time.indexOf('-') > 0) {
          return time;
        }

        return getYYYYMMDD(time);
      }

      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
.article-unit {
  position: relative;
  display: inline-block;
  width: 591px;
  height: 152px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid rgba(17, 19, 23, 0.1);
  padding: 24px;
  cursor: pointer;
  transition: background-color 0.2s linear;

  &.hover-effect:hover {
    background-color: rgba(8, 48, 93, 0.04);
  }

  &.hover-effect:active:not(:disabled) {
    background: rgba(8, 48, 93, 0.08);
  }

  &-title {
    font-size: 18px;
    font-weight: 600;
    color: #333840;
    line-height: 24px;
    margin-bottom: 8px;
  }

  &-content {
    font-size: 12px;
    font-weight: 400;
    color: #6D7582;
    height: 40px;
    line-height: 20px;
    margin-bottom: 12px;
  }

  &-boot {
    @include flex-align-center();
    color: #6D7582;
    line-height: 20px;
    font-size: 12px;
    justify-content: space-between;

    .article-tag {
      font-size: 12px;
      color: #9199a5;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      .tag {
        margin-right: 8px;
        background: rgba(8, 48, 93, 0.04);
        border-radius: 4px;
        padding: 0 6px;
        display: inline-block;
      }
    }
  }
  &-time {
    flex: 1;
  }
  &-time, &-hits {
    display: flex;
    align-items: center;
    .view {
      width: 16px;
      height: 16px;
      display: inline-block;
      margin-right: 6px;
    }
  }
}
</style>
